import { defineMessages } from 'react-intl'

export default defineMessages({
  admin: {
    id: 'Admin',
    defaultMessage: 'Admin'
  },
  dateAdded: {
    id: 'OrganizationUsersPage.DateAdded',
    defaultMessage: 'Date Added'
  },
  delete: {
    id: 'ConfirmDelete',
    defaultMessage: 'Really want to delete?'
  },
  deleteSubMessage: {
    id: 'OrganizationUsersPage.ConfirmDeleteSubMessage',
    defaultMessage: 'This user will be removed from your organization'
  },
  email: {
    id: 'Email',
    defaultMessage: 'User Name'
  },
  loadingUsers: {
    id: 'OrganizationUsersPage.LoadingUsers',
    defaultMessage: 'Loading Users'
  },
  name: {
    id: 'Name',
    defaultMessage: 'Name'
  },
  no: {
    id: 'No',
    defaultMessage: 'No'
  },
  noUsers: {
    id: 'OrganizationUsersPage.NoUsers',
    defaultMessage: 'There are no users in this organization that match the search criteria.'
  },
  remove: {
    id: 'OrganizationUsersPage.RemovingFromOrg',
    defaultMessage: 'Removing user from organization'
  },
  search: {
    id: 'OrganizationUsersPage.Search',
    defaultMessage: 'Search'
  },
  users: {
    id: 'users',
    defaultMessage: 'users'
  },
  yes: {
    id: 'Yes',
    defaultMessage: 'Yes'
  },
  loading: {
    id: 'loading',
    defaultMessage: 'Loading users...'
  }
})
